import styled from "styled-components";

const colors = {
  blank: "#ffffff",
  blue: "#1b5c8c",
  gray: "#686868",
  green: "#43aa27",
  orange: "#f17b27",
  red: "#bc0010",
  yellow: "#efc822",
};

const getBackgroundImage = (color) => {
  switch (color) {
    case "green":
      return { backgroundImage: "linear-gradient(90deg, transparent 50%, rgba(255, 255, 255, 0.3) 50%);" };
    case "orange":
      return { backgroundImage: "linear-gradient(135deg, transparent 50%, rgba(255, 255, 255, 0.3) 50%);" };
    case "blue":
      return { backgroundImage: "linear-gradient(45deg, transparent 50%, rgba(255, 255, 255, 0.3) 50%);" };
    case "gray":
      return { backgroundImage: "linear-gradient(0deg, transparent 50%, rgba(255, 255, 255, 0.3) 50%);" };
    default:
      return {};
  }
};

const CustomWorkOrderFieldIndicator = styled.div(({ color, highlight, theme }) => {
  const baseStyle = {
    borderRadius: "2px",
    display: "inline-block",
    height: "12px",
    minHeight: "12px",
    minWidth: "12px",
    width: "12px",
  };

  const colorStyle = color
    ? {
        backgroundColor: colors[color],
        ...getBackgroundImage(color),
      }
    : {};

  const highlightStyle = highlight
    ? {
        "&:after": {
          borderColor: theme.colors.categorical3,
          borderRadius: "50%",
          borderStyle: "solid",
          borderWidth: "2px",
          content: "''",
          display: "block",
          height: "18px",
          marginLeft: "-5px",
          marginTop: "-5px",
          width: "18px",
        },
      }
    : {};

  return { ...baseStyle, ...colorStyle, ...highlightStyle };
});

export default CustomWorkOrderFieldIndicator;
